import {FaSolidIcon} from "../../components/FontAwesomeIcons";
import React from "react";

export const BOOKIZON_PLUS_BENEFITS = [
    <span>Sincronizzare i tuoi appuntamenti con Google Calendar per essere sempre puntuale.</span>,
    <span>Inserirti in lista di attesa e ricevere una notifica se si libera il tuo orario preferito</span>,
    <span>Prenota appuntamenti massivi: scegli un periodo ricorrente e conferma fino a 12 appuntamenti presso un&apos;attività a tua scelta.</span>,
    <span>Ottieni il badge esclusivo <FaSolidIcon name={"badge"}/> accanto al tuo nome e visibile ad ogni attività e sull'app Bookizon</span>,
    <span>Tantissime altre novità in arrivo nei prossimi mesi!</span>
];
